import React, { createContext } from 'react';
import { PropertyCardFragment } from '../../gatsby-graphql';

export type ListingOrder = 'Recientes' | 'Antiguos' | 'Baratos' | 'Caros';

export interface IPropertiesFiltersContext {
  priceDeltas: [number, number];
  priceValues: [number, number];
  setPriceValues: React.Dispatch<React.SetStateAction<[number, number]>>;
  bedroomCount: number;
  setBedroomCount: React.Dispatch<React.SetStateAction<number>>;
  bathroomCount: number;
  setBathroomCount: React.Dispatch<React.SetStateAction<number>>;
  garagesCount: number;
  setGaragesCount: React.Dispatch<React.SetStateAction<number>>;
  checkedPropertySpecs: string[];
  handlePropertySpecChange(checked: boolean, name: string): void;
  filterProperties: PropertyCardFragment[];
  filterPropertiesLength: number;
  listingType: 'grid' | 'list';
  setListingType: React.Dispatch<React.SetStateAction<'grid' | 'list'>>;
  setListingOrder: React.Dispatch<React.SetStateAction<ListingOrder>>;
  listingOrderList: { value: ListingOrder; label: ListingOrder }[];
  isDrawerOpen: boolean;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isTouched: boolean;
}

const PropertiesFiltersContext = createContext<IPropertiesFiltersContext>({
  priceDeltas: [0, 0],
  priceValues: [0, 0],
  setPriceValues: () => null,
  bedroomCount: 0,
  setBedroomCount: () => null,
  bathroomCount: 0,
  setBathroomCount: () => null,
  garagesCount: 0,
  setGaragesCount: () => null,
  checkedPropertySpecs: [],
  handlePropertySpecChange: () => null,
  filterProperties: [],
  filterPropertiesLength: 0,
  listingType: 'grid',
  setListingType: () => null,
  setListingOrder: () => null,
  listingOrderList: [],
  isDrawerOpen: false,
  setIsDrawerOpen: () => null,
  isTouched: false,
});

export default PropertiesFiltersContext;
